import script from "./MyAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAlert.vue?vue&type=script&setup=true&lang=js"

import "./MyAlert.vue?vue&type=style&index=0&id=e78d6874&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78d6874"]])

export default __exports__